'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSite$002dLogin$002dPath$0024$0024anon$0024124 from "./presto.types$-Site-Login-Path$$anon$124.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SiteLoginPath$() {
  this.cbo = null;
  this.cbp = false;
  this.cbm = null;
  this.cbn = false;
  this.cbq = null;
  this.cbr = false;
}
export { $c_Lpresto_types$SiteLoginPath$ as $c_Lpresto_types$SiteLoginPath$ };
$p = $c_Lpresto_types$SiteLoginPath$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SiteLoginPath$;
/** @constructor */
function $h_Lpresto_types$SiteLoginPath$() {
}
export { $h_Lpresto_types$SiteLoginPath$ as $h_Lpresto_types$SiteLoginPath$ };
$h_Lpresto_types$SiteLoginPath$.prototype = $p;
$p.cIp = (function() {
  if ((!this.cbp)) {
    this.cbo = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.cbp = true;
  }
  return this.cbo;
});
$p.iM = (function() {
  if ((!this.cbn)) {
    this.cbm = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.cbn = true;
  }
  return this.cbm;
});
$p.cJe = (function() {
  if ((!this.cbr)) {
    this.cbq = new $j_presto$002etypes$0024$002dSite$002dLogin$002dPath$0024$0024anon$0024124.$c_Lpresto_types$SiteLoginPath$$anon$124(this);
    this.cbr = true;
  }
  return this.cbq;
});
var $d_Lpresto_types$SiteLoginPath$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SiteLoginPath$, "presto.types$SiteLoginPath$", ({
  a1M: 1,
  D: 1
}));
export { $d_Lpresto_types$SiteLoginPath$ as $d_Lpresto_types$SiteLoginPath$ };
var $n_Lpresto_types$SiteLoginPath$;
function $m_Lpresto_types$SiteLoginPath$() {
  if ((!$n_Lpresto_types$SiteLoginPath$)) {
    $n_Lpresto_types$SiteLoginPath$ = new $c_Lpresto_types$SiteLoginPath$();
  }
  return $n_Lpresto_types$SiteLoginPath$;
}
export { $m_Lpresto_types$SiteLoginPath$ as $m_Lpresto_types$SiteLoginPath$ };
//# sourceMappingURL=presto.types$-Site-Login-Path$.js.map
